import { formatMoney } from "@api/money";
import Order from "@api/types/order";
import React, { FC } from "react";

import {
  CostInfo,
  CostLabel,
  CostsDiv,
  ExtraCosts,
  InfoDiv,
  Information,
  ProductHeader,
  ProductHeaderSpan,
  ProductInfo,
  ProductLi,
  ProductList,
} from "@components/OrderHistoryTable/styles";

import OrderBillingInfo from "../OrderBillingInfo";
import OrderShippingInfo from "../OrderShippingInfo";

const OrderHistoryOrder: FC<{ order: Order; visible: boolean }> = ({ order, visible }) => {
  const getBillingInfo = (order: Order) => {
    return {
      firstName: order.billingFirstName,
      lastName: order.billingLastName,
      dealership: order.billingCompany,
      addressOne: order.billingAddress1,
      addressTwo: order.billingAddress2,
      city: order.billingCity,
      state: order.billingState,
      zip: order.billingPostalCode,
      country: order.billingCountry,
      phone: order.billingPhone,
      email: order.billingEmail,
    };
  };

  const getShippingInfo = (order: Order) => {
    return {
      firstName: order.shippingFirstName,
      lastName: order.shippingLastName,
      dealership: order.shippingCompany,
      addressOne: order.shippingAddress1,
      addressTwo: order.shippingAddress2,
      city: order.shippingCity,
      state: order.shippingState,
      zip: order.shippingPostalCode,
      country: order.shippingCountry,
      phone: order.shippingPhone,
      email: order.shippingEmail,
    };
  };

  return (
    <>
      <div className="OrderHistoryOrder">
        <ProductList>
          <ProductHeader>
            <ProductHeaderSpan style={{ width: "33%", textAlign: "left" }}>Title</ProductHeaderSpan>
            <ProductHeaderSpan style={{ width: "22%" }}>Delivery Format</ProductHeaderSpan>
            <ProductHeaderSpan style={{ width: "22%", textAlign: "right" }}>Quantity</ProductHeaderSpan>
            <ProductHeaderSpan style={{ width: "22%", textAlign: "right" }}>Price</ProductHeaderSpan>
          </ProductHeader>
          {order.cart.map((product, index) => (
            <ProductLi key={index}>
              <div
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  margin: "0",
                  borderBottom: "1px solid rgb(194, 194, 194)",
                }}>
                <InfoDiv style={{ width: "33%", textAlign: "left" }}>
                  <ProductInfo>{product.title}</ProductInfo>
                </InfoDiv>
                <InfoDiv style={{ width: "22%" }}>
                  <ProductInfo>{product.deliveryFormat}</ProductInfo>
                </InfoDiv>
                <InfoDiv style={{ width: "22%", textAlign: "right" }}>
                  <ProductInfo>{product.qtySold}</ProductInfo>
                </InfoDiv>
                <InfoDiv style={{ width: "22%", textAlign: "right" }}>
                  <ProductInfo>{formatMoney(product.listPrice)}</ProductInfo>
                </InfoDiv>
              </div>
            </ProductLi>
          ))}
        </ProductList>
        <ExtraCosts>
          <CostsDiv>
            <CostLabel>Sub Total</CostLabel>
            <CostInfo>{formatMoney(order.subtotal)}</CostInfo>
          </CostsDiv>
          {order.discountTotal > 0 && (
            <CostsDiv>
              <CostLabel>Discount:</CostLabel>
              <CostInfo>{formatMoney(-order.discountTotal)}</CostInfo>
            </CostsDiv>
          )}
          <CostsDiv>
            <CostLabel>Tax</CostLabel>
            <CostInfo>{formatMoney(order.taxTotal)}</CostInfo>
          </CostsDiv>
          <CostsDiv>
            <CostLabel>Shipping</CostLabel>
            <CostInfo>{formatMoney(order.shippingTotal)}</CostInfo>
          </CostsDiv>
          <CostsDiv>
            <CostLabel>Handling</CostLabel>
            <CostInfo>{formatMoney(order.handlingTotal)}</CostInfo>
          </CostsDiv>
          <CostsDiv>
            <CostLabel>Total</CostLabel>
            <CostInfo>{formatMoney(order.total)}</CostInfo>
          </CostsDiv>
        </ExtraCosts>
        <Information>
          <OrderBillingInfo data={getBillingInfo(order)} />
          <OrderShippingInfo data={getShippingInfo(order)} />
        </Information>
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .OrderHistoryOrder {
            border-top: 1px solid rgb(194, 194, 194);
            display: ${visible ? "block" : "none"};
          }
        `}
      </style>
    </>
  );
};

export default OrderHistoryOrder;
